import { EventListener } from "./Event";
import { Layout } from "../components/layout/Layout";
import { LayoutLoadEvent } from "./LayoutLoadEvent";

export interface LayoutLoadOutermostListener extends EventListener {
    (event: LayoutLoadOutermostEvent): void;
}

export class LayoutLoadOutermostEvent extends LayoutLoadEvent {
    private _outermostLayout: Layout;

    constructor(target: Layout, outermostLayout: Layout) {
        super(target);
        this._outermostLayout = outermostLayout;
    }

    public get outermostLayout(): Layout {
        return this._outermostLayout;
    }
}
